exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.date-range .date-range__pickers input {\n    border: none;\n}\n", ""]);

// exports
